
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1606981867189",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3106",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M896 478.72C878.336 478.72 864 464.384 864 446.72L864 200.192 594.624 469.504C582.656 481.472 563.264 481.472 551.296 469.504 539.328 457.536 539.328 438.144 551.296 426.176L818.752 158.72 576 158.72C558.336 158.72 544 144.384 544 126.72 544 109.056 558.336 94.72 576 94.72L893.056 94.72C897.728 94.016 901.568 95.232 906.112 96.768 907.584 97.28 908.992 97.792 910.336 98.496 913.152 99.904 916.48 99.648 918.784 102.016 920.448 103.68 920.064 106.112 921.28 108.032 924.288 112.064 926.208 116.736 927.04 121.856 927.104 122.752 927.552 123.456 927.488 124.288 927.552 125.12 928 125.888 928 126.72L928 446.72C928 464.384 913.664 478.72 896 478.72ZM205.248 862.72 448 862.72C465.664 862.72 480 877.056 480 894.72 480 912.384 465.664 926.72 448 926.72L130.944 926.72C126.272 927.424 122.432 926.208 117.888 924.672 116.416 924.16 115.008 923.648 113.664 922.944 110.848 921.536 107.52 921.792 105.216 919.424 103.552 917.76 103.936 915.328 102.72 913.408 99.712 909.376 97.792 904.704 96.96 899.584 96.896 898.688 96.448 897.984 96.512 897.152 96.448 896.32 96 895.552 96 894.72L96 574.72C96 557.056 110.336 542.72 128 542.72 145.664 542.72 160 557.056 160 574.72L160 821.248 429.376 551.936C441.344 539.968 460.736 539.968 472.704 551.936 484.672 563.904 484.672 583.296 472.704 595.264L205.248 862.72Z",
        "p-id": "3107"
      }
    }
  ]
})
    }
  